import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

import slide1 from '../assets/home-slide/1.png';
import slide2 from '../assets/home-slide/2.png';
import slide3 from '../assets/home-slide/3.png';
import slide4 from '../assets/home-slide/4.png';
import slide5 from '../assets/home-slide/5.png';
import slide7 from '../assets/home-slide/7.png';

const textVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const HalfPageSection = ({ images }) => {

  const [currentIndex, setCurrentIndex] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    const startAutoSlide = () => {
      timerRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000);
    };

    startAutoSlide();
    return () => clearInterval(timerRef.current);
  }, [images.length]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    clearInterval(timerRef.current);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    clearInterval(timerRef.current);
  };

  return (
    <div className="flex flex-col  lg:flex-row bg-[#D9D9D9]/20 pt-8 px-4 md:py-20 md:px-10 lg:px-32 xl:px-48 overflow-hidden max-w-[1600px] mx-auto">

      {/* Image Section */}
      <div className="w-full lg:w-[40%] relative min-h-[300px] sm:min-h-[400px] md:min-h-[450px] lg:min-h-[500px]">
 {images.map((imageObj, index) => (
  <div
    key={index}
    className={`absolute inset-0 transition-opacity hidden md:block duration-500 ${
      index === currentIndex ? 'opacity-100' : 'opacity-0'
    }`}
  >
    <img
      src={imageObj.src}
      alt={imageObj.alt}
      title={imageObj.title}
      className="w-full h-full rounded-lg object-contain md:object-contain lg:object-cover"
    />
  </div>
))}
  <div className="relative md:hidden block w-full aspect-[4/3]">
  {images.map((imageObj, index) => (
  <div
    key={index}
    className={`absolute inset-0 transition-opacity duration-500 ${
      index === currentIndex ? 'opacity-100' : 'opacity-0'
    }`}
  >
    <img
      src={imageObj.src}
      alt={imageObj.alt}
      title={imageObj.alt}
      className="object-contain md:object-cover w-full h-full rounded-lg"
    />
  </div>
))}
  </div>
        {/* Indicators */}
        <div className="absolute top-[20rem] sm:top-[33rem] md:top-[30rem] lg:top-[35rem] left-1/2 -translate-x-1/2 flex space-x-2 z-10">
          {images.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full  ${
                index === currentIndex ? 'bg-[#FF5300]' : 'bg-gray-400'
              } cursor-pointer`}
            ></div>
          ))}
        </div>
      </div>

      {/* Text Section */}
      <div className="w-full lg:w-[80%] pt-16 sm:pt-24 md:pt-12  p-2 md:p-10 lg:p-16 xl:p-20 text-start mx-auto">
      <motion.h2
  className="text-2xl md:text-3xl  pb-4 lg:text-[2.5rem] font-bold text-black poppins-font tracking-wider"
  initial="hidden"
  animate="visible"
  variants={textVariants}
>
  <div>We Are <span className="text-[#FF5300]">Making</span></div>
  <div className="mt-4">
    <span className="text-[#FF5300] ">Ideas Better</span> For Everyone
  </div>
  <hr className="w-14 bg-black h-[2px] mt-4 border-none shadow-lg mb-7 hidden sm:block" />
</motion.h2>


        <motion.p
          className="md:text-[18px] text-[14px] lg:text-base text-gray-600 text-left poppins-font2 leading-relaxed"
          initial="hidden"
          animate="visible"
          variants={textVariants}
          transition={{ delay: 0.3 }}
        >
          Welcome to the future of land-based slot gaming at Fusion Spin! Our Land Slots Platform
          provides a comprehensive, user-friendly system designed to elevate the gaming experience.
          By integrating state-of-the-art features, robust hardware, and advanced jackpot systems,
          we ensure both operators and players enjoy unmatched reliability, efficiency, and excitement.
          <br /><br />
          Whether you're an operator looking to enhance your offerings or a player seeking an immersive
          gaming experience, our platform delivers seamless performance and endless entertainment.
          Be a part of the revolution as we shape the future of slot gaming.
        </motion.p>
      </div>
    </div>
  );
};

const Slide = () => {
const images = [
  { src: slide1, alt: "Land Slots Machine",title: "Land Slots Machine" },
  { src: slide2, alt: "Casino Slots Machine", title: "Casino Slots Machine" },
  { src: slide3, alt: "User Interface of Slot Platform", title: "User Interface of Slot Platform" },
  { src: slide4, alt: "Casino Land Slots Machine", title: "Casino Land Slots Machine" },
  { src: slide5, alt: "Land Based Slots Machine", title: "Land Based Slots Machine" },
  { src: slide7, alt: "Modern Land Based Slots Machines", title: "Modern Land Based Slots Machines" }
];
  return <HalfPageSection images={images} />;
};

export default Slide;
